/* eslint-disable @typescript-eslint/no-unused-vars */
import IconConfiguration from 'assets/icons/ic_menu_configuration.svg';
import IconDashboard from 'assets/icons/ic_menu_dashboard.svg';
import IconEmployee from 'assets/icons/ic_menu_employee.svg';
import IconEquipment from 'assets/icons/ic_menu_equipment.svg';
import IconInsurance from 'assets/icons/ic_menu_insurance.svg';
import IconLeaveOff from 'assets/icons/ic_menu_leaveoff_manager.svg';
import IconMyPage from 'assets/icons/ic_menu_mypage.svg';
import IconOnOffboard from 'assets/icons/ic_menu_onoffboard_manager.svg';
import IconTimesheet from 'assets/icons/ic_menu_timesheet_manager.svg';
import IconWatchingList from 'assets/icons/ic_menu_watchinglist.svg';
import IconProjectManager from 'assets/icons/ic_menu_project_manager.svg';
import IconOvertime from 'assets/icons/ic_menu_overtime.svg';

import DashboardModuleIcon from 'assets/icons/dashboardModuleIcon.png';

import { IMenuList } from 'components/interfaces/MenuListSidebar';
import {
  COMPULSORY_INSURANCE_HR,
  PERMISSION_CATEGORY_MANAGE,
  PERMISSION_DASHBOARD_ACCESS,
  PERMISSION_DEPARTMENT_MANAGE,
  PERMISSION_DEVICE_ACCESS_PERSONNEL,
  PERMISSION_DEVICE_INVENTORY,
  PERMISSION_DEVICE_MANAGE,
  PERMISSION_EMAIL_TEMPLATE_MANAGE,
  PERMISSION_LEAVE_OFF_ACCESS_PERSONAL,
  PERMISSION_LEAVE_OFF_MANAGE,
  PERMISSION_OFFBOARD_ACCESS_PERSONNEL,
  PERMISSION_OFFBOARD_MANAGE_EMPLOYEE,
  PERMISSION_ONBOARD_ACCESS_PERSONNEL,
  PERMISSION_ONBOARD_MANAGE_EMPLOYEE,
  PERMISSION_ONBOARD_MANAGE_PROCESS,
  PERMISSION_PAYSLIP_ACCESS_PERSONAL,
  PERMISSION_PERMISSION_MANAGE,
  PERMISSION_PERSONNEL_MANAGE,
  PERMISSION_PERSONNEL_RECORD_ACTIVE_DEACTIVE,
  PERMISSION_PERSONNEL_RECORD_APPROVAL,
  PERMISSION_PERSONNEL_RECORD_REQUEST_APPROVAL,
  PERMISSION_POSITION_MANAGE,
  PERMISSION_TIMEKEEPING_ACCESS_PERSONAL,
  PERMISSION_TIMESHEET_ACCESS_OBSERVATION_LIST,
  PERMISSION_TIMESHEET_ACCESS_PERSONAL,
  PERMISSION_TIMESHEET_MANAGE_EMPLOYEE,
  PERMISSION_TIMESHEET_MONTH_APPROVAL,
  PERMISSION_TIMESHEET_REQUEST_APPROVAL,
  PERMISSION_TIMESHEET_SELF_APPROVE,
  PERMISSION_WATCHINGLIST_MANAGE,
  PERMISSION_WORKSHIFT_MANAGE,
  SCHEDULE_INCREASE_HR,
  SCHEDULE_INCREASE_PARTICIPANT_LIST,
  PERMISSION_GENERAL_MANAGE,
  PERMISSION_PROJECT_MANAGE,
  PERMISSION_OVERTIME_MANAGE,
  PERMISSION_PAYROLL,
  PERMISSION_WORKFLOW,
} from 'constants/permissions';
import React, { useEffect } from 'react';
import { labelMenu } from '../../constants/label';
import { PermissionType } from 'hrm-common/extensions/enums/personel';
import { MoneyCollectOutlined } from '@ant-design/icons';
import { useAppSelector } from 'app/hooks';
import { selectConfiguration } from 'features/configuration/configurationSlice';

const Icon = (props: any) => (
  <span
    role="img"
    aria-label="fast-backward"
    className="anticon anticon-fast-backward ant-menu-item-icon"
  >
    <img alt="" src={props.src} />
  </span>
);

const MenuListManager: IMenuList[] = [
  {
    title: labelMenu.DASHBOARD,
    path: '/dashboard',
    icon: <Icon src={IconDashboard} />,
    permissions: [PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_HR],
    iconModule: <Icon src={DashboardModuleIcon} />,
  },
  {
    title: labelMenu.REPORT,
    path: '/report',
    icon: <Icon src={IconEmployee} />,
    permissions: [PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_HR],
  },
  {
    title: labelMenu.MY_PAGE,
    path: '/my-page',
    icon: <Icon src={IconMyPage} />,
    menu: [
      {
        title: labelMenu.TIMESHEET,
        path: '/timesheet',
        permissions: [PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL],
      },
      {
        title: labelMenu.PAYSLIP,
        path: '/payslip',
        permissions: [PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL],
      },
      {
        title: labelMenu.TIMEKEEPING,
        path: '/timekeeping',
        permissions: [PERMISSION_TIMEKEEPING_ACCESS_PERSONAL],
      },
      {
        title: labelMenu.LEAVE_OFF,
        path: '/leave-off',
        permissions: [PERMISSION_LEAVE_OFF_ACCESS_PERSONAL],
      },
      // {
      //   //Tạm ẩn tính năng chưa phát triển xong
      //   title: labelMenu.PAYSLIP,
      //   path: '/payslip',
      //   permissions: [PERMISSION_PAYSLIP_ACCESS_PERSONAL],
      // },
      // {
      //   //Tạm ẩn tính năng chưa phát triển xong
      //   title: labelMenu.CONTRACT,
      //   path: '/contract',
      //   permissions: [PERMISSION_PAYSLIP_ACCESS_PERSONAL],
      // },
      // {
      //   //Tạm ẩn tính năng chưa phát triển xong
      //   title: labelMenu.DEVICE,
      //   path: '/device',
      //   permissions: [PERMISSION_DEVICE_ACCESS_PERSONNEL.DEVICE_ACCESS_PERSONNEL],
      // },
      // {
      //   title: labelMenu.ON_OFF_BOARD,
      //   path: '/on-off',
      //   menu: [
      //     {
      //       title: labelMenu.ONBOARD,
      //       path: '/onboard',
      //       permissions: [PERMISSION_ONBOARD_ACCESS_PERSONNEL.ONBOARD_ACCESS_PERSONNEL],
      //     },
      //     {
      //       title: labelMenu.OFFBOARD,
      //       path: '/offboard',
      //       permissions: [PERMISSION_OFFBOARD_ACCESS_PERSONNEL.OFFBOARD_ACCESS_PERSONNEL],
      //     },
      //   ],
      //   permissions: [
      //     PERMISSION_ONBOARD_ACCESS_PERSONNEL.ONBOARD_ACCESS_PERSONNEL,
      //     PERMISSION_OFFBOARD_ACCESS_PERSONNEL.OFFBOARD_ACCESS_PERSONNEL,
      //   ],
      // },
      {
        title: labelMenu.OBSERVATION_LIST,
        path: '/observation_list',
        permissions: [
          PERMISSION_TIMESHEET_ACCESS_OBSERVATION_LIST.TIMESHEET_ACCESS_OBSERVATION_LIST,
        ],
      },
    ],
    permissions: [
      PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL,
      PERMISSION_TIMEKEEPING_ACCESS_PERSONAL,
      PERMISSION_LEAVE_OFF_ACCESS_PERSONAL,
      PERMISSION_PAYSLIP_ACCESS_PERSONAL,
      PERMISSION_DEVICE_ACCESS_PERSONNEL.DEVICE_ACCESS_PERSONNEL,
      PERMISSION_ONBOARD_ACCESS_PERSONNEL.ONBOARD_ACCESS_PERSONNEL,
      PERMISSION_OFFBOARD_ACCESS_PERSONNEL.OFFBOARD_ACCESS_PERSONNEL,
      PERMISSION_TIMESHEET_ACCESS_OBSERVATION_LIST.TIMESHEET_ACCESS_OBSERVATION_LIST,
    ],
  },
  {
    title: labelMenu.EMPLOYEE_MANAGE,
    path: '/employee',
    icon: <Icon src={IconEmployee} />,
    permissions: [
      PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE,
      PERMISSION_PERSONNEL_RECORD_REQUEST_APPROVAL,
      PERMISSION_PERSONNEL_RECORD_APPROVAL,
      PERMISSION_PERSONNEL_RECORD_ACTIVE_DEACTIVE,
    ],
  },
  {
    title: labelMenu.WATCHING_LIST_MANAGE,
    path: '/manage-watching-list',
    icon: <Icon src={IconWatchingList} />,
    menu: [
      {
        title: labelMenu.WATCHING_LIST,
        path: '/watching-list',
        permissions: [PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_VIEW],
      },
      {
        title: labelMenu.WATCHING_LIST_MANAGER_REQUEST_LIST,
        path: '/manager-request-list',
        permissions: [PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_MANAGER_REQUEST_LIST_VIEW],
      },
      {
        title: labelMenu.WATCHING_LIST_HR_REQUEST_LIST,
        path: '/hr-request-list',
        permissions: [PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_HR_REQUEST_LIST_VIEW],
      },
    ],
    permissions: [
      PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_VIEW,

      PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_MANAGER_REQUEST_LIST_VIEW,
      PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_HR_REQUEST_LIST_VIEW,
    ],
  },
  {
    title: labelMenu.TIMESHEET_MANAGE,
    path: '/manage',
    icon: <Icon src={IconTimesheet} />,
    menu: [
      {
        title: labelMenu.TIMESHEET_REQUEST_APPROVAL,
        path: '/request_approval',
        permissions: [PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_APPROVAL],
        extraPermissions: ['PROJECT_LEADER'],
      },
      {
        title: labelMenu.TIMESHEET_APPROVAL,
        path: '/timesheet_approval',
        permissions: [PERMISSION_TIMESHEET_MONTH_APPROVAL],
      },
      {
        title: labelMenu.TIMESHEET_EMPLOYEE_TIMESHEET,
        path: '/employee_timesheet',
        permissions: [
          PERMISSION_TIMESHEET_MANAGE_EMPLOYEE.TIMESHEET_MANAGE_EMPLOYEE,
          PERMISSION_TIMESHEET_MANAGE_EMPLOYEE.TIMESHEET_VIEW_EMPLOYEE,
        ],
      },
      {
        title: labelMenu.TIMESHEET_REQUEST_PENDING,
        path: '/request_pending',
        permissions: [PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_APPROVAL],
        extraPermissions: ['PROJECT_LEADER'],
      },
    ],
    permissions: [
      PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_APPROVAL,
      PERMISSION_TIMESHEET_MONTH_APPROVAL,
      PERMISSION_TIMESHEET_MANAGE_EMPLOYEE.TIMESHEET_MANAGE_EMPLOYEE,
      PERMISSION_TIMESHEET_MANAGE_EMPLOYEE.TIMESHEET_VIEW_EMPLOYEE,
      PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_PENDING,
    ],
    extraPermissions: ['PROJECT_LEADER'],
  },
  // {
  //   title: labelMenu.ON_OFF_BOARD_MANAGE,
  //   path: '/onboard-offboard',
  //   icon: <Icon src={IconOnOffboard} />,
  //   menu: [
  //     {
  //       title: labelMenu.ONBOARD_EMPLOYEE,
  //       path: '/employee-onboard',
  //       permissions: [PERMISSION_ONBOARD_MANAGE_EMPLOYEE.ONBOARD_MANAGE_EMPLOYEE],
  //     },
  //     {
  //       title: labelMenu.OFFBOARD_EMPLOYEE,
  //       path: '/employee-offboard',
  //       permissions: [PERMISSION_OFFBOARD_MANAGE_EMPLOYEE.OFFBOARD_MANAGE_EMPLOYEE],
  //     },
  //   ],
  //   permissions: [
  //     PERMISSION_ONBOARD_MANAGE_EMPLOYEE.ONBOARD_MANAGE_EMPLOYEE,
  //     PERMISSION_OFFBOARD_MANAGE_EMPLOYEE.OFFBOARD_MANAGE_EMPLOYEE,
  //   ],
  // },
  {
    title: labelMenu.MANAGE_LEAVE_OFF,
    path: '/manage-leave-off',
    icon: <Icon src={IconLeaveOff} />,
    permissions: [PERMISSION_LEAVE_OFF_MANAGE.LEAVE_OFF_MANAGE_ACCESS],
  },
  {
    title: labelMenu.MANAGE_PROJECT,
    path: '/manage-project',
    icon: <Icon src={IconProjectManager} />,
    permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
  },
  {
    title: labelMenu.MANAGE_PROJECT_HISTORY,
    path: '/history-manage-project',
    icon: <Icon src={IconProjectManager} />,
    permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
  },
  {
    title: labelMenu.MANAGE_OVERTIME,
    path: '/manage-overtime',
    icon: <Icon src={IconOvertime} />,
    menu: [
      {
        title: labelMenu.OVERTIME_PLAN_REQUEST,
        path: '/overtime-plan-request',
        permissions: [],
        extraPermissions: ['PROJECT_LEADER'],
      },
      {
        title: labelMenu.OVERTIME_PLAN_REQUEST_HISTORY,
        path: '/history-overtime-plan-request',
        permissions: [],
        extraPermissions: ['PROJECT_LEADER'],
      },
      {
        title: labelMenu.OVERTIME_APPROVAL,
        path: '/overtime-approval',
        permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
      },
      {
        title: labelMenu.OVERTIME_APPROVAL_HISTORY,
        path: '/history-overtime-approval',
        permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
      },
      {
        title: labelMenu.MANAGE_OVERTIME_TYPE,
        path: '/manage-overtime-type',
        permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
      },
    ],
    permissions: [
      PERMISSION_OVERTIME_MANAGE.OVERTIME_PLAN_VIEW,
      PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE,
    ],
    extraPermissions: ['PROJECT_LEADER'],
  },
  // {
  //   title: labelMenu.EQUIPMENT_MANAGE,
  //   path: '/equipment',
  //   icon: <Icon src={IconEquipment} />,
  //   menu: [
  //     {
  //       title: labelMenu.EQUIPMENT_INVENTORY_CONTROL,
  //       path: '/inventory-control',
  //       permissions: [PERMISSION_DEVICE_INVENTORY.DEVICE_INVENTORY],
  //     },
  //     {
  //       title: labelMenu.EQUIPMENT_HANDOVER,
  //       path: '/equipment-handover',
  //       permissions: [PERMISSION_DEVICE_MANAGE.DEVICE_MANAGE],
  //     },
  //   ],
  //   permissions: [
  //     PERMISSION_DEVICE_INVENTORY.DEVICE_INVENTORY,
  //     PERMISSION_DEVICE_MANAGE.DEVICE_MANAGE,
  //   ],
  // },
  {
    title: labelMenu.INSURANCE_MANAGE,
    path: '/insurance',
    icon: <Icon src={IconInsurance} />,
    menu: [
      {
        title: labelMenu.INSURANCE_COMPLUSURY_LIST,
        path: '/complusory-insurance',
        permissions: [SCHEDULE_INCREASE_HR.SCHEDULE_INCREASE_DECREASE],
      },
      {
        title: labelMenu.INSURANCE_SETTING,
        path: '/setting-insurance',
        permissions: [COMPULSORY_INSURANCE_HR.COMPULSORY_INSURANCE_SETTING],
      },
    ],
    permissions: [
      SCHEDULE_INCREASE_HR.SCHEDULE_INCREASE_DECREASE,
      COMPULSORY_INSURANCE_HR.COMPULSORY_INSURANCE_SETTING,
      SCHEDULE_INCREASE_PARTICIPANT_LIST.PARTICIPANT_DETAIL_VIEW,
    ],
  },
  {
    title: labelMenu.PAYROLL,
    path: '/payroll',
    icon: <MoneyCollectOutlined style={{ fontSize: '22px' }} />,
    menu: [
      {
        title: labelMenu.VIEW_EMPLOYEE_INFO,
        path: '/view-employee',
        permissions: [PermissionType.VIEW_EMPLOYEE_PAYROLL_INFO],
      },
      {
        title: 'Pay Runs',
        path: '/pay-runs',
        permissions: [PermissionType.VIEW_PAYRUNS_INFO],
      },
      // {
      //   title: 'Manage Request',
      //   path: '/manage-request',
      //   permissions: [PERMISSION_PERSONNEL_MANAGE.PERSONNEL_MANAGE],
      // },
    ],
    permissions: [PermissionType.VIEW_EMPLOYEE_PAYROLL_INFO, PermissionType.VIEW_PAYRUNS_INFO],
  },
  // { //Tạm ẩn tính năng chưa phát triển xong
  //   title: labelMenu.CONTRACT_MANAGE,
  //   path: '/contract',
  //   icon: <Icon src={IconContract} />,
  //   menu: [
  //     {
  //       title: labelMenu.CONTRACT_TEMPLATE,
  //       path: '/contract-template',
  //       permissions: [PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE],
  //     },
  //     {
  //       title: labelMenu.CONTRACT_EMPLOYEE,
  //       path: '/contract-list',
  //       permissions: [PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE],
  //     },
  //   ],
  //   permissions: [PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE],
  // },
  {
    title: labelMenu.CONFIGURATION,
    path: '/configuration',
    icon: <Icon src={IconConfiguration} />,
    menu: [
      {
        title: labelMenu.CONFIGURATION_CATEGORY,
        path: '/category',
        permissions: [PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_DEPARTMENT,
        path: '/department',
        permissions: [PERMISSION_DEPARTMENT_MANAGE.DEPARTMENT_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_POSITION,
        path: '/position',
        permissions: [PERMISSION_POSITION_MANAGE.POSITION_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_ROLE,
        path: '/role',
        permissions: [PERMISSION_PERMISSION_MANAGE.PERMISSION_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_WORKSHIFT,
        path: '/workshift',
        permissions: [PERMISSION_WORKSHIFT_MANAGE.WORKSHIFT_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_PAYROLL,
        path: '/payroll',
        permissions: [PermissionType.SETUP_PAYROLL],
      },
      {
        title: labelMenu.CONFIGURATION_STATUS,
        path: '/status',
        permissions: [PermissionType.SETUP_WORKFLOW],
      },
      {
        title: labelMenu.CONFIGURATION_ACTION,
        path: '/action',
        permissions: [PermissionType.SETUP_WORKFLOW],
      },
      {
        title: labelMenu.CONFIGURATION_WORKFLOW_TYPE,
        path: '/workflow-type',
        permissions: [PermissionType.SETUP_WORKFLOW],
      },
      {
        title: labelMenu.CONFIGURATION_SETUP_POLICY,
        path: '/setup-policy',
        permissions: [PERMISSION_PERMISSION_MANAGE.PERMISSION_MANAGE],
      },
      {
        title: labelMenu.CONFIGURATION_SETUP_WORKFLOW,
        path: '/setup-workflow',
        permissions: [
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_PROCESS,
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_TASK,
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_EVALUATE,
        ],
      },
      {
        title: labelMenu.CONFIGURATION_SETUP_MENU_SCREEN,
        path: '/menu-screen',
        permissions: [
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_PROCESS,
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_TASK,
          PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_EVALUATE,
        ],
      },
      // {
      //   title: labelMenu.CONFIGURATION_WORK_SHIFTS,
      //   path: '/work-shift',
      //   //icon: <Icon src={IconOnOffboard} />,
      //   menu: [
      //     {
      //       title: labelMenu.CONFIGURATION_SETUP_WORK_SHIFTS,
      //       path: '/setup-work-shifts',
      //       permissions: [PERMISSION_WORKSHIFT_MANAGE.WORKSHIFT_MANAGE],
      //     },
      //     {
      //       title: labelMenu.CONFIGURATION_MANAGE_WORK_SHIFTS,
      //       path: '/manage-assign-work-shifts',
      //       permissions: [PERMISSION_WORKSHIFT_MANAGE.WORKSHIFT_MANAGE],
      //     },
      //   ],
      //   permissions: [PERMISSION_WORKSHIFT_MANAGE.WORKSHIFT_MANAGE],
      // },
      {
        title: labelMenu.CONFIGURATION_MANAGE_MAIL_AND_NOTIFICATION,
        path: '/manage-mail-&-notification',
        permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
        menu: [
          {
            title: labelMenu.CONFIGURATION_MANAGE_MAIL_TEMPLATES,
            path: '/manage-mail-templates',
            permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
          },
          {
            title: labelMenu.CONFIGURATION_MANAGE_AUTO_SEND_MAIL,
            path: '/auto-send-mail',
            permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
          },
          {
            title: labelMenu.CONFIGURATION_MANAGE_NOTIFICATION,
            path: '/config-notification',
            permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
          },
        ],
      },
      {
        title: labelMenu.CONFIGURATION_GENERAL,
        path: '/general-setting',
        permissions: [PERMISSION_GENERAL_MANAGE.GENERAL_MANAGE],
      },
    ],
    permissions: [
      PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE,
      PERMISSION_DEPARTMENT_MANAGE.DEPARTMENT_MANAGE,
      PERMISSION_POSITION_MANAGE.POSITION_MANAGE,
      PERMISSION_PERMISSION_MANAGE.PERMISSION_MANAGE,
      PERMISSION_WORKSHIFT_MANAGE.WORKSHIFT_MANAGE,
      PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_PROCESS,
      PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_MANAGE_TASK,
      PERMISSION_ONBOARD_MANAGE_PROCESS.ONBOARD_EVALUATE,
      PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE,
      PermissionType.SETUP_PAYROLL,
      PermissionType.SETUP_WORKFLOW,
    ],
  },
  // { //Tạm ẩn tính năng chưa phát triển xong
  //   title: labelMenu.PRODUCT_MANAGE,
  //   path: '/product',
  //   icon: <Icon src={IconProduct} />,
  //   permissions: [PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL],
  // },
];
// const arrDataFake = [
//   {
//     menuParent: 'Configuration',
//     dataMenuScreen: [
//       {
//         id: 1,
//         subMenu: 'Manage Categories',
//         screen: 'Manage Categories',
//         path: '/configuration/category',
//         permissions: [PERMISSION_CATEGORY_MANAGE.CATEGORY_MANAGE],
//       },
//       {
//         id: 2,
//         subMenu: 'Manage Mail & Notifi',
//         screen: 'Manage Mail',
//         path: '/configuration/manage-mail-&-notification/manage-mail-templates',
//         permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
//       },
//       {
//         id: 3,
//         subMenu: 'Manage Mail & Notifi',
//         screen: 'Config noti',
//         path: '/configuration/manage-mail-&-notification/config-notification',
//         permissions: [PERMISSION_EMAIL_TEMPLATE_MANAGE.EMAIL_TEMPLATE_MANAGE],
//       },
//     ],
//   },
// ];

// let MenuListManager = arrDataFake?.map((item) => {
//   const pathParent = item?.dataMenuScreen[0].path.split('/')[1];

//   return {
//     title: item.menuParent,
//     path: `/${pathParent}`,
//     permissions: item?.dataMenuScreen?.map((itemData) => itemData?.permissions).flat(Infinity),

//     menu: Array.from(new Set(item?.dataMenuScreen.map((s) => s.subMenu))).map((lab) => {
//       let checkDuplicate = item?.dataMenuScreen
//         .filter((s) => s.subMenu === lab)
//         .map((edition) => edition.path);
//       if (checkDuplicate.length <= 1) {
//         return {
//           title: item?.dataMenuScreen.find((s) => s.subMenu === lab)?.screen,
//           path: '/' + item?.dataMenuScreen.find((s) => s.subMenu === lab)?.path.split('/')[2],
//           permissions: item?.dataMenuScreen.find((s) => s.subMenu === lab)?.permissions,
//         };
//       } else {
//         return {
//           title: lab,
//           path: '/' + item?.dataMenuScreen.find((s) => s.subMenu === lab)?.path.split('/')[2],
//           permissions: item?.dataMenuScreen
//             .filter((s) => s.subMenu === lab)
//             ?.map((itemData) => itemData?.permissions)
//             .flat(Infinity),

//           menu: item?.dataMenuScreen
//             .filter((s) => s.subMenu === lab)
//             ?.map((itemData) => {
//               return {
//                 title: itemData.screen,
//                 path: '/' + itemData?.path.split('/')[3],
//                 permissions: itemData?.permissions,
//               };
//             }),
//         };
//       }
//     }),
//   };
// });

export default MenuListManager;
